export enum ActionDisplayType
    {
        None,
        Approval_Modal,
        Approval_Confirm,

        Confirmation_Modal,
        Confirmation_whatever
        
    }